import React from 'react';
import NavigationItem from './NavigationItem';
import { useDispatch, useSelector } from 'react-redux';
import { ExitToAppOutlined } from '@mui/icons-material';
import { userLogout } from '../../store/user';
import { NavBar, NavigationList, MobileContainer } from './styles';
import useLocalStorage from '../../hooks/useLocalStorage';
import NavigationMobile from './NavigationMobile';
import useEventListener from '../../hooks/useEventListener';

export default function Navigation({ pages }) {
  const [navigation, setAppSettings] = useLocalStorage('navigation', false);
  const handleOpenMenu = () => setAppSettings(!navigation);

  useEventListener('keydown', (event) => {
    if (
      event.code === 'KeyM' &&
      event.target.nodeName !== 'INPUT' &&
      event.target.nodeName !== 'TEXTAREA' &&
      event.target.nodeName !== 'SELECT'
    ) {
      setAppSettings(!navigation);
    }
  });

  const { data } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    const confirm = window.confirm('Você realmente quer sair?');
    if (confirm) {
      dispatch(userLogout());
    }
  };

  return (
    <NavBar open={navigation} aria-label="principal">
      <NavigationList open={navigation}>
        <MobileContainer>
          <NavigationMobile open={navigation} setOpen={handleOpenMenu} />
        </MobileContainer>
        {pages.map(({ roles, groups, navigation, icon, title, path }, i) => {
          const userRole = roles.some((role) => role === data?.roles);
          const userGroup = groups.some((group) => data?.userGroup.includes(group));
          const result = Array.isArray(navigation)
            ? navigation.some((group) => data?.userGroup.includes(group))
            : navigation;

          return (
            userRole &&
            userGroup &&
            result && (
              <NavigationItem key={i} icon={icon} title={title} url={path} />
            )
          );
        })}
        <NavigationItem
          url="/"
          icon={
            <ExitToAppOutlined
              style={{ width: '35px', height: '35px', color: '#fff' }}
            />
          }
          title="Sair"
          onClick={handleSubmit}
        />
      </NavigationList>
    </NavBar>
  );
}
